<div class="mb" [style.height]="height()" [attr.aria-busy]="loading() && !error() ? 'true' : null">
  @if (offlineMock) {
    <!-- The offline mock answers API calls, not Metabase's iframe -->
    <div class="mb__state">
      <span class="bk-sym mb__glyph" aria-hidden="true">insert_chart</span>
      <p class="mb__title">Dashboard not available offline</p>
      <p class="mb__body">
        This dashboard loads from Metabase, which the offline mock cannot serve. Run the console against a live
        environment to see it.
      </p>
    </div>
  } @else {
    @if (iframeUrl()) {
      <iframe
        class="mb__frame"
        [class.is-shown]="!loading()"
        [src]="iframeUrl()"
        [title]="frameTitle()"
        allow="fullscreen"
        (load)="onFrameLoad($event)"
      ></iframe>
    }

    @if (error()) {
      <div class="mb__state" role="alert">
        <span class="bk-sym mb__glyph" aria-hidden="true">cloud_off</span>
        <p class="mb__title">The dashboard did not load</p>
        <p class="mb__body">{{ error() }}</p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="retry()">
          <span class="bk-sym" aria-hidden="true">refresh</span>
          Try again
        </button>
      </div>
    } @else if (slow()) {
      <div class="mb__state mb__state--over">
        <span class="bk-sym mb__glyph" aria-hidden="true">hourglass_empty</span>
        <p class="mb__title">The dashboard is taking longer than usual</p>
        <p class="mb__body">
          Metabase may be busy or blocked on this network. Keep waiting, or reload it.
        </p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="retry()">
          <span class="bk-sym" aria-hidden="true">refresh</span>
          Reload dashboard
        </button>
      </div>
    } @else if (loading()) {
      <div class="mb__skel" aria-hidden="true">
        <div class="mb__skel-tiles">
          @for (tile of [1, 2, 3, 4]; track tile) {
            <span class="bk-skel mb__skel-tile"></span>
          }
        </div>
        <div class="mb__skel-charts">
          <span class="bk-skel mb__skel-chart"></span>
          <span class="bk-skel mb__skel-chart"></span>
        </div>
      </div>
    }

    <!-- Always in the page, so screen readers hear each change of state. -->
    <span class="bk-sr-only" role="status">{{
      error() ? "" : slow() ? "The dashboard is taking longer than usual" : loading() ? "Loading the dashboard" : ""
    }}</span>
  }
</div>
